"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeDependencyInstance = exports.AppState = exports.LogLevel = exports.DATA_REPORT_CHANNEL = void 0;
const expect_js_1 = __importDefault(require("expect.js"));
const rxjs_1 = require("rxjs");
const interfaces_1 = require("../interfaces");
var DATA_REPORT_CHANNEL;
(function (DATA_REPORT_CHANNEL) {
    DATA_REPORT_CHANNEL["enumFirebase"] = "channel_firebase";
    DATA_REPORT_CHANNEL["enumAppsflyer"] = "channel_appsflyer";
    DATA_REPORT_CHANNEL["enumMixpanel"] = "channel_mixpanel";
})(DATA_REPORT_CHANNEL || (exports.DATA_REPORT_CHANNEL = DATA_REPORT_CHANNEL = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["LEVEL_ALL"] = 0] = "LEVEL_ALL";
    LogLevel[LogLevel["LEVEL_VERBOSE"] = 0] = "LEVEL_VERBOSE";
    LogLevel[LogLevel["LEVEL_DEBUG"] = 1] = "LEVEL_DEBUG";
    LogLevel[LogLevel["LEVEL_INFO"] = 2] = "LEVEL_INFO";
    LogLevel[LogLevel["LEVEL_WARNING"] = 3] = "LEVEL_WARNING";
    LogLevel[LogLevel["LEVEL_ERROR"] = 4] = "LEVEL_ERROR";
    LogLevel[LogLevel["LEVEL_FATAL"] = 5] = "LEVEL_FATAL";
    LogLevel[LogLevel["LEVEL_NONE"] = 6] = "LEVEL_NONE";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var AppState;
(function (AppState) {
    AppState["enterToForeground"] = "enterToForeground";
    AppState["backToBackground"] = "backToBackground";
})(AppState || (exports.AppState = AppState = {}));
class DataRetriver {
    constructor() {
        this.tradeDependency = undefined;
        this.multi = new rxjs_1.AsyncSubject();
        this.appState = new rxjs_1.Subject();
    }
    /**
     * 设置client数据源
     * @param dataSource
     */
    setTradeDependency(dataSource) {
        this.tradeDependency = dataSource;
        this.multi.next("init_done");
        this.multi.complete();
    }
    getProductType() {
        if (process && process.env.PLATFORM) {
            return process.env.PLATFORM;
        }
        if (this.tradeDependency && this.tradeDependency.getPlatform) {
            return this.tradeDependency.getPlatform();
        }
        return interfaces_1.PRODUCT_TYPE.BU;
    }
    getLocalStorage() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.instanceLocalStorage();
    }
    log(level, tag, message) {
        var _a;
        if ((_a = this.tradeDependency) === null || _a === void 0 ? void 0 : _a.log) {
            this.tradeDependency.log(level, tag, message);
        }
    }
    getMarketSymbol(market) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getMarketSymbol(market);
    }
    getSymbolInfo(symbol, market) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getSymbolInfo(symbol, market);
    }
    getMarketSymbolAsync(market) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getMarketSymbolAsync(market);
    }
    recordAppRuntimeStateEvent(event, state, message) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        if (this.tradeDependency.recordRuntimeStatusEvent) {
            this.tradeDependency.recordRuntimeStatusEvent(event, state, message);
        }
    }
    /**
     * 获取ticker推送
     */
    getTickerWsStream() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getTickerWsStream();
    }
    getTradingToken() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getTradingToken();
    }
    /**
     * 获取aws token
     */
    getAccessToken(force = false) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getAccessToken(force);
    }
    /**
     * 获取key云端id
     * @param key
     */
    getApiKeyCloudId(key) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("getApiKeyId");
        return this.tradeDependency.getApiKeyId(key);
    }
    /**
     * 是否支持V2接口
     * @param market
     */
    isSupportV2(market) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("isSupportV2");
        return this.tradeDependency.isSupportV2(market);
    }
    /**
     * 获取rsa公钥
     */
    getRSAPublicKey() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("getRSAPublicKey");
        return this.tradeDependency.getRSAPublicKey();
    }
    /**
     * 获取运行中的host信息
     */
    getRunTimeHost() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        return this.tradeDependency.getRunTimeHost();
    }
    getIsChina() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("getIsChina");
        return this.tradeDependency.getIsChina();
    }
    reportSignatureTimeoutData(data) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("reportSignatureTimeoutData");
        return this.tradeDependency.reportSignatureTimeoutData(data);
    }
    refreshApiCloudKeyId(cloudKeyId, apiKey) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("refreshApiCloudKeyId");
        return this.tradeDependency.refreshApiCloudKeyId(cloudKeyId, apiKey);
    }
    reportBURequestError(data) {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("reportBURequestError");
        return this.tradeDependency.reportBURequestError(data);
    }
    // 埋点上报
    dataReport(name, channel, params) {
        var _a, _b;
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("dataReport");
        (_b = (_a = this.tradeDependency) === null || _a === void 0 ? void 0 : _a.dataReport) === null || _b === void 0 ? void 0 : _b.call(_a, name, channel, params);
    }
    // 请求评分
    queryAppraiseAction(from) {
        var _a, _b;
        (_b = (_a = this.tradeDependency) === null || _a === void 0 ? void 0 : _a.queryAppraiseAction) === null || _b === void 0 ? void 0 : _b.call(_a, from);
    }
    // 本地化错误
    localizeError(error) {
        var _a, _b, _c;
        if ((_a = this.tradeDependency) === null || _a === void 0 ? void 0 : _a.localizeError) {
            return (_c = (_b = this.tradeDependency) === null || _b === void 0 ? void 0 : _b.localizeError) === null || _c === void 0 ? void 0 : _c.call(_b, error);
        }
        return error;
    }
    // 获取当前userId
    getUserId() {
        (0, expect_js_1.default)(this.tradeDependency).to.not.be.empty();
        (0, expect_js_1.default)(this.tradeDependency).to.have.property("getUserId");
        return this.tradeDependency.getUserId();
    }
}
let gInstance;
function getTradeDependencyInstance() {
    if (!gInstance) {
        gInstance = new DataRetriver();
    }
    return gInstance;
}
exports.getTradeDependencyInstance = getTradeDependencyInstance;
